var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{staticClass:"notification",attrs:{"color":_vm.notification.color,"rounded":"lg"}},[_c('span',{staticClass:"notification-text"},[_vm._v(_vm._s(_vm.notification.message))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }